module.exports = "/images/vessel-8.jpg";